var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"m-background",class:['m-background--media-' + _vm.getLevel]}),_vm._v(" "),_c('Header'),_vm._v(" "),_c('div',{staticClass:"l-container l-container--with-header"},[_c('ChooseLevel'),_vm._v(" "),_c('img',{staticClass:"m-logo m-logo--bottom-left",attrs:{"src":require("@/assets/images/rics-logo.png")}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ca43cf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ChooseLevel.vue
// module id = null
// module chunks = 